import angular from "angular";

angular
    .module('app')
    .component('clientsImportForm', {
        template: require('./clients-import-form.html'),
        controller: ['$http', 'Upload', 'notifier', '$scope', '$uibModal', controller],
        bindings: {
            organization: '<',
            fields: '<',
        }
    });

function controller($http, Upload, notifier, $scope, $uibModal) {

    const $ctrl = this;

    $ctrl.file = null;

    $ctrl.items = null;

    $ctrl.uploadFile = () => {
        $ctrl.loading = true;

        Upload.upload({
            url: `/clients/parse-excel`,
            data: {file: $ctrl.file}
        }).then(
            res => {
                $ctrl.loading = false;
                $ctrl.items = res.data;

                $ctrl.items.forEach(item => {
                    item.fieldValues = {};

                    $ctrl.fields.forEach(field => {
                        const fieldValue = item.field_values.find(v => +v.field_id === +field.id);
                        item.fieldValues[field.id] = fieldValue ? fieldValue.value : null;
                    });
                })
            },
            err => {
                $ctrl.loading = false;
                notifier.errorResponseNotify(err);
            }
        );
    };

    $ctrl.confirm = async function () {
        $ctrl.confirmLoading = true;

        $ctrl.items.forEach(item => {
            item.status = 'waiting';
        });

        for (let i = 0; i < $ctrl.items.length; i++) {
            const client = $ctrl.items[i];

            try {
                if (client.id) {
                    await $http.post(`/clients/${client.id}`, client)
                } else {
                    await $http.post('/clients', client);
                }

                client.status = 'success';
            } catch (err) {
                client.status = 'error';
                client.errorMessages = err.data.messages;
            }

            $scope.$apply();
        }
    };

    $ctrl.showErrors = function (client) {
        $uibModal.open({
            component: 'clientImportErrorMessages',
            resolve: {
                client() {
                    return client;
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/clients-import-form/clients-import-form.js